import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';

export const type = 'legacyApp';

const API_BASE = '/api/developer/v1/apps';

export const api = buildEntityApi(type, path => `${API_BASE}/${path}`);

export const selectors = buildEntitySelectors(type);

export const actions = buildEntityActions(type, selectors, api);
